const isProduction = () => {
  var _process, _process$env;

  return ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === "production";
};

export default isProduction;